export const getPrismicDoc = (axiosInstance, uid, type) => {
    const url = `/v2/content/fetch-by-uid/${uid}/${type}`;
    return axiosInstance.get(url);
};
